import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ErrorBoundary from './components/ErrorBoundary'
import ProtectedRoute from './components/ProtectedRoute'
import './index.css'
import Home from './pages/Home'
import ListingDetail from './pages/ListingDetail'
import Auth from './pages/Auth'
import Onboarding from './pages/Onboarding'
import ListItem from './pages/ListItem'
import MyBookings from './pages/MyBookings'
import MyListings from './pages/MyListings'
import Profile from './pages/Profile'
import Referrals from './pages/Referrals'
import Terms from './pages/Terms'
import ProhibitedItems from './pages/ProhibitedItems'
import Admin from './pages/Admin'
import Messages from './pages/Messages'
import HowItWorks from './pages/HowItWorks'
import Payouts from './pages/Payouts'
import Favourites from './pages/Favourites'
import Privacy from './pages/Privacy'
import Support from './pages/Support'
import Payment from './pages/Payment'
import OwnerProfile from './pages/OwnerProfile'
import NotFound from './pages/NotFound'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import VerifyResult from './pages/VerifyResult'
import Unsubscribed from './pages/Unsubscribed'
import Wanted from './pages/Wanted'
import WantedNew from './pages/WantedNew'

export default function App() {
return (
<ErrorBoundary>
<AuthProvider>
<BrowserRouter>
<Routes>
<Route path="/" element={<Home />} />
<Route path="/listing/:id" element={<ListingDetail />} />
<Route path="/auth" element={<Auth />} />
<Route path="/forgot-password" element={<ForgotPassword />} />
<Route path="/reset-password" element={<ResetPassword />} />
<Route path="/onboarding" element={<Onboarding />} />
<Route path="/list-item" element={<ListItem />} />
<Route path="/verify-result" element={<VerifyResult />} />
<Route path="/unsubscribed" element={<Unsubscribed />} />
<Route path="/my-bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
<Route path="/my-listings" element={<ProtectedRoute allowDemo><MyListings /></ProtectedRoute>} />
<Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
<Route path="/referrals" element={<ProtectedRoute><Referrals /></ProtectedRoute>} />
<Route path="/terms" element={<Terms />} />
<Route path="/prohibited-items" element={<ProhibitedItems />} />
<Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
<Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
<Route path="/how-it-works" element={<HowItWorks />} />
<Route path="/payouts" element={<ProtectedRoute><Payouts /></ProtectedRoute>} />
<Route path="/favourites" element={<ProtectedRoute><Favourites /></ProtectedRoute>} />
<Route path="/privacy" element={<Privacy />} />
<Route path="/support" element={<Support />} />
<Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
<Route path="/user/:id" element={<OwnerProfile />} />
<Route path="/wanted" element={<Wanted />} />
<Route path="/wanted/new" element={<ProtectedRoute><WantedNew /></ProtectedRoute>} />
<Route path="/wanted/:area" element={<Wanted />} />
<Route path="*" element={<NotFound />} />
</Routes>
</BrowserRouter>
</AuthProvider>
</ErrorBoundary>
)
}